/* 

Use this page if you want to use azure authentication

-Jomel Nerveza

*/
import React, { useState, useEffect } from "react";
import { Switch } from "react-router-dom";
import Axios from "axios";

import { MDBContainer } from "mdbreact";

import Routes from "./components/Routes";

const App = () => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const [pageTitle, setPageTitle] = useState("");
  const [brand, setBrand] = useState("");

  const [frmDef, setDefaults] = useState({
    apiServer: "",
    apiServerHybrid: "",
    deployURL: "",
    brand: "",
    apiServerPOS: "",
  });
  const [sDefaultFile, setDefaultFile] = useState("");

  const LoadDefaultFile = () => {
    if (window.location.hostname === "localhost") {
      setDefaultFile("/defaultslocal.json");
    } else {
      setDefaultFile("/defaults.json");
    }
  };

  function loadDefaults() {
    // console.log(sDefaultFile);

    Axios.get(process.env.PUBLIC_URL + sDefaultFile)
      .then((res) => {
        setDefaults({
          ...frmDef,
          apiServer: res.data[1].apiServer,
          apiServerHybrid: res.data[2].apiServerHybrid,
          deployURL: res.data[3].deployURL,
          brand: res.data[0].brand,
          apiServerPOS: res.data[4].apiServerPOS,
        });

        sessionStorage.setItem("brand", res.data[0].brand);
        setBrand(res.data[0].brand);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    LoadDefaultFile();
    if (sDefaultFile !== "") {
      loadDefaults();
    }
  }, [sDefaultFile]);

  if (frmDef.apiServer === "") {
    return (
      <React.Fragment>
        <h1></h1>
        <br />
        <img
          src={frmDef.deployURL + "/loading.gif"}
          style={{ width: "150px", textAlign: "center" }}
          alt="loading"
        />
        <br />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <MDBContainer fluid className="pt-5 mt-5">
          <Switch>
            <Routes
              deployURL={frmDef.deployURL}
              apiServer={frmDef.apiServer}
              apiServerHybrid={frmDef.apiServerHybrid}
              apiServerPOS={frmDef.apiServerPOS}
              pageTitle={pageTitle}
              setPageTitle={setPageTitle}
            />
          </Switch>
        </MDBContainer>
      </React.Fragment>
    );
  }
};

export default App;
